import { render, staticRenderFns } from "./RegisterBuyingStation.vue?vue&type=template&id=489df89b&scoped=true"
import script from "./RegisterBuyingStation.vue?vue&type=script&lang=js"
export * from "./RegisterBuyingStation.vue?vue&type=script&lang=js"
import style0 from "./RegisterBuyingStation.vue?vue&type=style&index=0&id=489df89b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489df89b",
  null
  
)

export default component.exports